import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { Subscription } from 'rxjs'
import { InputText } from 'primeng/inputtext'
import { GlobalSearchService } from './global-search.service'

@Component({
  selector: 'app-global-search',
  templateUrl: 'global-search.html',
  styleUrl: 'global-search.css',
  imports: [
    FormsModule,
    InputText,
  ],
})
export class GlobalSearchComponent implements OnInit, OnDestroy {
  globalSearchService = inject(GlobalSearchService)

  @Input({ required: true }) uniqueKey!: string

  public query: string = ''
  private globalSearchValueSubscription?: Subscription

  ngOnInit (): void {
    // listen for updates to the value, probably coming from the filter service
    this.globalSearchValueSubscription = this.globalSearchService.getValue().subscribe(valueMap => {
      for (const [key, value] of valueMap) {
        if (key === this.uniqueKey) {
          this.query = value || ''
        }
      }
    })
  }

  ngOnDestroy () {
    this.globalSearchValueSubscription?.unsubscribe()
  }

  onClickSearch (clear: boolean = false) {
    if (clear) this.query = ''
    // update search value
    this.globalSearchService.setValue({ uniqueKey: this.uniqueKey, value: this.query })
    // trigger search
    this.globalSearchService.setTrigger(this.uniqueKey)
  }
}
